module.exports = "<div class=\"c-tickertape\" ng-if=\"vm.content\">\n  <div class=\"c-tickertape__wrap\">\n    <div class=\"c-tickertape__ticker\" ng-style=\"vm.tickerStyle\">\n     \t<div class=\"c-tickertape__item\" ng-bind-html=\"vm.content\"></div>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/content-types/tickertape/tickertape.html
// module id = 441
// module chunks = 0